<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar>
        <ion-title>Make Appointments</ion-title>
        <ion-buttons slot="start">
          <ion-back-button href="/"></ion-back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-item>
        <ion-label>MM DD YY</ion-label>
        <ion-datetime
          display-format="MM/DD/YYYY"
          :value="appointmentDate"
          ref="theAppointmentDate"
          name="appointmentDate"
          id="appointmentDate"
          placeholder="Select Date"
          @ionChange="onChange($event)"
        ></ion-datetime>
      </ion-item>
      <ion-list v-if="openAppointments.length > 0">
        <ion-item
          text-center
          v-for="openAppointment in openAppointments"
          :key="openAppointment.slotID"
        >
          <ion-label>
            <ion-button
              style="width: 90%;"
              @click="
                makeAppointment(
                  openAppointment.slotID,
                  openAppointment.appointmentDescription
                )
              "
              >{{ openAppointment.appointmentDescription }}</ion-button
            >
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </div>
</template>

<script>
import Repository from "../../repositories/RepositoryFactory";
const AppointmentsRepository = Repository.get("appointments");

export default {
  name: "adminmainpage",
  model: "",
  appointmentDate: "",
  data() {
    return {
      openAppointments: [],
      appointmentDate: ""
    };
  },
  //        <ion-datetime v-bind:value="model" v-bind:ionChange="model = $event.target.value"> </ion-datetime>
  methods: {
    changePassword() {
      let self = this;
      self.$router.push({ name: "change" });
    },

    //onChange(event) {
    onChange: async function(event) {
      this.appointmentDate = this.$refs.theAppointmentDate.value;
      // eslint-disable-next-line no-console
      console.log(event);
      const result = await AppointmentsRepository.getUntakenShotAppointments(
        this.appointmentDate + "~" + this.$store.state.otherLocation
      );

      // eslint-disable-next-line no-console
      //console.log(event.target.value);
      this.openAppointments = result.data;
      //eslint-disable-next-line no-console
      console.log(result.data);
    },
    //onChange: async function(event) {
    makeAppointment: async function(slotId, appointmentDescription) {
        let self = this;
      // eslint-disable-next-line no-console
      //console.log(event);
      var makeAppointmentParameters = {
        AppointmentDescription: appointmentDescription,
        Location: this.$store.state.otherLocation,
        userName: this.$store.state.otherUserName,
        SlotId: slotId,
        UserId: this.$store.state.otherUserId
      };

      const result = await AppointmentsRepository.createShotAppointment(
        makeAppointmentParameters
      );

      if (result.data.status === "Success") {
        alert("Appointment Created");
        self.$router.push({ name: "otherpatientsscreenone" });        
      } else {
        alert("Appointment Not Created");
      }

      //eslint-disable-next-line no-console
      console.log(result.data);
    }
  }
};
</script>
